<template>
    <div class="scatter_echart_box" style="height: 293px;">
      <v-chart
          class="scatter_echart"
          :option="options"
          style="width: 100%;height: 330px"
          autoresize
          ref="scatterEchartRef"
      />
    </div>
</template>
<script>
import { 
  ref,
  watch
} from 'vue'
import { use } from "echarts/core"
import { CanvasRenderer } from "echarts/renderers"
import { ScatterChart } from "echarts/charts"
import {
    TooltipComponent,
    LegendComponent,
    TitleComponent,
    SingleAxisComponent,
} from "echarts/components"
use([
  CanvasRenderer,
  ScatterChart,
  LegendComponent,
  TooltipComponent,
  TitleComponent,
  SingleAxisComponent,
]);
import VChart from "vue-echarts"
export default {
    name : 'UniaxialScatterEchart',
    components: {
         VChart
    },
    props: {
       data_list:{
        default:[]
       }
    },
    setup(props){
      const options = ref(null);
      const setOptionsFn = (list)=>{
        let seriesData = [];
        list.forEach(item => {
          seriesData.push([item.price>60?62+(item.price-60)/200:item.price==0?3:item.price*1,item.total_score*1,item.model_name])
        });
        options.value={
          grid: {
            top: 5,
            left: 50,
            right: 0,
            bottom: 30
          },
          xAxis: [{
            axisLabel:{
              formatter:(val)=>{
                return val>60||val==0?'':val==60?val+'万+':val+'万'
              }
            }
          }],
          yAxis:{
            show:true
            // type:'value'
          },
          tooltip:{
            show:true,
            formatter:(params)=>{
              return `
                <div>
                  <span>车系：</span><span>${params.value[2]}</span>
                </div>
                <div>
                  <span>分数：</span><span>${params.value[1]}</span>
                </div>
              `;
            }
          },
          series:[
            {
              type: 'scatter',
              symmbolSize:30,
              colorBy: "data",
              data:seriesData
            }
          ]
        }
      }
      watch(()=>props.data_list,(new_val)=>{
        if(new_val && new_val.length){
          setOptionsFn(JSON.parse(JSON.stringify(new_val)));
        }
      })
      return {
        options
      }
    }
}
</script>